<template>
  <div>
    <ScoreJianluList
      :row="row.start"
      :list="row.list"
      :broadcast="row.jianlu_broadcast"
      :start-id="$route.query.start_id"
    />
 
  </div>
</template>

<script>
import {Toast} from "vant";
import ScoreJianluList from "@/components/score/ScoreJianluList.vue"; 
export default {
  name: "ScoreShow",
  data: function () {
    return {
      row: {
        start: {},
        saiqu: {},
        list: [],
        jianlu_broadcast: null,
      }
    }
  },
  components: {
    ScoreJianluList 
  },
  filters: {},
  mounted() {
    let that = this;
    document.title="数据展示"
    that.fetch()
    // 换成轮询
    that.timer = setInterval(function () {
      that.fetch()
    }, 2000)
  },
  destroyed() {
    // 销毁监听
    // this.socket.close()
    clearInterval(this.timer)
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.post('/api/dscore/scoreStartSubjectList', {
        saiqu: that.$route.query.saiqu,
        start_id: that.$route.query.start_id,
      }, (res) => {
        that.row = res.data;
      }, (res) => { 
          Toast(res.msg)
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// JianluShow.vue?b0889036